module.exports = __webpack_public_path__ + "static/img/ec4f7d6c6c6e36a1d6e7fbced77badc8.00650a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ec4f7d6c6c6e36a1d6e7fbced77badc8.jpg
// module id = 0aL8
// module chunks = 4